// **React Imports
import { memo } from 'react'

// **MUI Imports
import { Box, CircularProgress, Typography } from '@mui/material'

// **SCSS Imports
import './index.scss'

const OverlayLoading = ({ text }) => {
  return (
    <Box className="loading-container">
      <CircularProgress />
      {text && (
        <Typography
          sx={{
            color: 'var(--common-white)',
            fontSize: '14px',
            fontWeight: 500
          }}
        >
          {text}
        </Typography>
      )}
    </Box>
  )
}

export default memo(OverlayLoading)
